/*
 * @Author: Czy
 * @Date: 2025-01-11 14:09:37
 * @FilePath: /museum-wechat/src/service/platform-city/index.ts
 *
 */
import { http } from '@/utils/http'
import {
  CountryListRes,
  CountryListQuery,
  AdCodeConvertQuery,
  AdCodeConvertDTO,
  ELongCountryListQuery,
} from './index.d'

// 行政区域-景点
export const getCountryList = (params?: CountryListQuery) => {
  return http.post<PageResult<CountryListRes>>('/query/bikecat/travel/adCode/list', params || {})
}
// 行政区域-酒店
export const eLongCountryList = (params?: ELongCountryListQuery) => {
  return http.post<PageResult<CountryListRes>>(
    '/query/bikecat/platformCity/city/in/country/list',
    params || {},
  )
}
// adCode转化(暂支支持艺龙)
export const adCodeConvert = (params: AdCodeConvertQuery) => {
  return http.post<Result<AdCodeConvertDTO>>('/query/bikecat/travel/adCode/convert', params)
}

//天地图获取adCode转化为cityId
export const geocodeConvert = (params: { location: string }) => {
  return http.get<Result<any>>(`/v1/geocode/convert`, params)
}
